module.exports = __webpack_public_path__ + "img/public_resources_arrow_next_active.4b99a6a2.svg";